import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAuthStore } from "../../store/authStore";
import { getAllPilots } from "../../api/authAPI";
import AddPilotTab from "./addPilotTab";
import DroneAssignmentTab from "./droneAssignmentTab";
import PilotAccordian from "./pilotAccordian";
import useDroneStore from "../../store/droneStore";
import { useEffect } from "react";

const ManagePilots = () => {

    const { token } = useAuthStore((state) => state)
    const { setAllPilots } = useDroneStore((state) => state)


    const [selectedIndex, setSelectedIndex] = useState(0)


    const pilots = useQuery(["getAllUser", token], () => getAllPilots(token))

    useEffect(() => {
        setAllPilots(pilots?.data?.data?.data)
    }, [pilots?.data?.data])








    const tabsData = [
        { title: "Add Pilot", tab: <AddPilotTab /> },
        { title: "Assign Drone", tab: <DroneAssignmentTab pilots={pilots?.data?.data?.data} /> }
    ]

    return (
        <>

            <div className="h-full w-full">
                <div className="p-4 h-full  flex flex-col space-x-6">
                    <div>
                        <h1 className="text-3xl border-b pb-4 w-full h-full ">Manage Pilots</h1>
                    </div>

                    <div className="w-full grid grid-cols-5">
                        <div className="w-1/2 h-full mt-10 col-span-2">
                            <div>

                                <ul class="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-zinc-200">
                                    {
                                        tabsData.map((data, index) => {
                                            return (
                                                <>
                                                    <li class="mr-2">
                                                        <p className={`inline-block p-4 ${selectedIndex === index ? "text-white bg-tblu" : "text-tblu"} font-semibold  cursor-pointer rounded-t-lg`} onClick={() => { setSelectedIndex(index) }}>{data.title}</p>
                                                    </li>
                                                </>
                                            )
                                        })
                                    }

                                </ul>

                            </div>
                            {tabsData[selectedIndex]?.tab}
                        </div>
                        <div className="w-full mt-10 col-span-3">
                            <div>
                                <div>
                                    <h1 className="text-2xl">Users List</h1>
                                </div>

                                {/* {
                                    subUsers?.data?.data?.data?.map((user) => {

                                        return (
                                            <> */}

                                {
                                    pilots?.data?.data?.data?.map((pilot) => (<PilotAccordian name={pilot.fullName} email={pilot.email} userId={pilot.userId} />))
                                }

                                {/* <div className="w-4/5 h-14 shadow-sm border rounded-xl border-zinc-400 mt-10 flex items-center p-4 justify-between">
                                    <div className="flex space-x-3">
                                        <div>
                                            <UserFilled style={{ color: "#2e5baa" }} size={24} />
                                        </div>
                                        <div>
                                            <p className="text-lg m-0"><span className="text-tblu font-semibold">Emaill:</span> tushar.jaiswal</p>
                                        </div>
                                    </div>
                                    <div>
                                        <p className="capitalize text-lg m-0"><span className="text-tblu font-semibold">Access Type:</span>pilot</p>
                                    </div>
                                    <div>
                                        <TrashCan style={{ color: "red" }} size={24} />
                                    </div>
                                </div> */}



                                {/* </>
                                        )
                                    })

                                } */}


                            </div>
                        </div>
                    </div>
                    {/* <hr /> */}

                </div>
            </div>
        </>
    )
}

export default ManagePilots;